import { atkEquipmentApi } from "common/state/portalApi/atkEquipment";
import { GetRigResponse } from "protos/portal/atk_equipment";
import { RigEffectiveConfig } from "protos/atk/effective_config";
import { robotApi } from "common/state/portalApi/robot";

export interface EffectiveConfigResponse {
  rigResponse: GetRigResponse | undefined;
  effectiveConfig: RigEffectiveConfig | undefined;
  isLoading: boolean;
  isFetching: boolean;
  isError: boolean;
  refetch: () => void;
}

export const useEffectiveConfig = (serial: string): EffectiveConfigResponse => {
  const { data } = robotApi.endpoints.getRobot.useQuery({ serial });
  const rigId = data?.robot?.activeAtkRigId;
  const {
    data: rigResult,
    isLoading,
    isFetching,
    isError,
    refetch,
  } = atkEquipmentApi.endpoints.getRig.useQuery(
    {
      id: rigId ?? "",
      validate: true,
    },
    { skip: !rigId }
  );
  return {
    rigResponse: rigResult,
    effectiveConfig: rigResult?.validationResult?.effectiveConfig,
    isLoading,
    isFetching,
    isError,
    refetch,
  };
};
